import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import { useConversationState } from './hooks/useConversationState.js';

const ConciergeContext = createContext(undefined);
const useConciergeContext = () => {
    const context = useContext(ConciergeContext);
    if (!context) {
        throw new Error('useConciergeContext must be used within ConciergeContextProvider');
    }
    return context;
};
const ConciergeContextProvider = ({ children, apiBaseUrl, onSignIn, isSignedIn, }) => {
    const conversationState = useConversationState();
    return (jsx(ConciergeContext.Provider, Object.assign({ value: Object.assign(Object.assign({}, conversationState), { apiBaseUrl, onSignIn, isSignedIn }) }, { children: children })));
};

export { ConciergeContextProvider, useConciergeContext };
//# sourceMappingURL=ConciergeContextProvider.js.map
